import React, {useEffect, useState} from 'react'
import Spinner from './../newsmonkey/Spinner';
import InfiniteScroll from "react-infinite-scroll-component";

const BreakbyClass = ()=>{
  const [state,setState]=useState([]);
  const [page,setPage]=useState(1);


    useEffect(() => {
      fetch(`http://localhost:8090/api/paginatedorder?page=${page}&limit=9`)
      .then((response) => response.json())
      .then(data => setState([data])); 
        //updateNews(); 
        // eslint-disable-next-line
    }, [page])


    const fetchMoreData = async () => {   
      setPage(page+1);
      fetch(`http://localhost:8090/api/paginatedorder?page=${page+1}&limit=9`)
      .then((response) => response.json())
      .then(data => setState(state=>[data])); 
      };
 
        return (
            <>
                <InfiniteScroll
                    dataLength={state.length}
                    next={fetchMoreData}
                    loader={<Spinner/>}
                > 
                    <div className="container">
                         
                    <div className="row">
                    {state.map((el,i)=>
            <div key={i} className="col-md-4 my-3">
                <div className="card">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        position: 'absolute',
                        right: '0'
                    }
                    }> 
                        <span className="badge rounded-pill bg-danger"> {el.RowNum} </span>
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">{el.FAULT_CODE}</h5>
                        <p className="card-text">Job No: {el.JOB_NO}</p>
                        <p className="card-text">Total Count: {el.TotalCount}</p>
                        <p className="card-text">Machine Code: {el.Machine_Code}</p>
                        <p className="card-text">Workshop No: {el.Workshop_No}</p>
                        <p className="card-text">OC Date: {el.OC_DATE}</p>
                        <p className="card-text">OKAYED Date: {el.OKAYED_DATE}</p>
                    </div>
                </div>
            </div>
            )}
                    </div>
                    </div> 
                </InfiniteScroll>
            </>
        )
    
}

export default BreakbyClass
